import AssetType from 'common/enums/assetTypes';
import EmptyTypes from 'common/enums/emptyTypes';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCallToActionsAction, getCallToActions, getCallToActionsPending } from 'redux/slices/callToActionSlice';
import { fetchGamesAction, getGames, getGamesPending } from 'redux/slices/gameSlice';
import { getMultimediaError } from 'redux/slices/multimediaSlice';
import { fetchStickersAction, getStickers, getStickersPending } from 'redux/slices/stickerSlice';
import EventFormSelectAssets from './EventFormSelectAssets';
import EventFormSelectAssetsFilter from './EventFormSelectAssetsFilters';

const EventFormSelectAllAssetsType = (props) => {
    const { selectedAssets, close, onConfirm, enableUserDataCapture, typesSelect } = props;
    const { t } = useTranslation();
    const error = useSelector(getMultimediaError);
    const callToActions = useSelector(getCallToActions);
    const stickers = useSelector(getStickers);
    const gamesArr = useSelector(getGames);
    const pendingCallToActions = useSelector(getCallToActionsPending);
    const pendingStickers = useSelector(getStickersPending);
    const pendingGames = useSelector(getGamesPending);
    const [name, setName] = useState('');
    const [type, setType] = useState(AssetType.STICKER);
    const games = gamesArr.filter((g) => g.type === type);

    const dispatch = useDispatch();

    const loadData = useCallback(() => {
        switch (type) {
            case AssetType.STICKER:
                dispatch(
                    fetchStickersAction({
                        filters: {
                            name: name,
                        },
                    }),
                );
                break;
            case AssetType.CALL_TO_ACTION:
                dispatch(
                    fetchCallToActionsAction({
                        filters: {
                            name: name,
                        },
                    }),
                );
                break;
            case AssetType.SURVEY:
            case AssetType.QUIZ:
                dispatch(
                    fetchGamesAction({
                        name: name,
                    }),
                );
                break;
            default:
                break;
        }
    }, [dispatch, name, type]);

    useEffect(() => {
        loadData();
    }, [name, type, loadData]);

    const getAssetsToShow = () => {
        switch (type) {
            case AssetType.STICKER:
                return stickers;
            case AssetType.CALL_TO_ACTION:
                return callToActions;
            case AssetType.QUIZ:
            case AssetType.SURVEY:
                return games;
            default:
                return [];
        }
    };

    const gamesType = enableUserDataCapture
        ? [
              {
                  value: AssetType.QUIZ,
                  name: t('event.eventFormSelectAssets.quiz'),
              },
          ]
        : [];

    const filter = (
        <EventFormSelectAssetsFilter
            type={type}
            setSearch={(n) => setName(n)}
            setType={(tp) => setType(tp)}
            typesSelect={[...gamesType, ...typesSelect]}
            searchMinLength={1}
        />
    );

    return (
        <EventFormSelectAssets
            search={name}
            sectionName={t('eventForm.assets')}
            filter={filter}
            emptyType={EmptyTypes.EMPTY_ASSETS}
            assets={getAssetsToShow()}
            emptyDescription={t('empty.assets')}
            emptyDescriptionNoAssets={t('eventAssets.emptyDescription.allAssetsType')}
            error={error}
            pending={pendingCallToActions || pendingStickers || pendingGames}
            selectedAssets={selectedAssets}
            close={close}
            onConfirm={onConfirm}
            loadMore={() => {}}
        />
    );
};

export default EventFormSelectAllAssetsType;
